import React from 'react';
import { Shield, Leaf, Clock } from 'lucide-react';

export const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="/about-team.jpg"
                  alt="Next Generation Tree Service Team"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              </div>
              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 bg-green-500 text-white p-6 rounded-xl shadow-lg">
                <div className="text-center">
                  <div className="text-4xl font-bold">10+</div>
                  <div className="text-sm">Years Serving</div>
                  <div className="text-sm">Nashville</div>
                </div>
              </div>
            </div>

            {/* Right Side - Content */}
            <div>
              <div className="inline-block bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                About Us
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Your Trusted Partner in{' '}
                <span className="text-green-600">Tree Care</span>
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Next Generation Tree Service & Landscaping is a locally owned and operated family business with over a decade of experience in residential and commercial arbor services. We're passionate about preserving and protecting the natural beauty of Nashville's trees and landscapes.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                As a nature-loving company, we believe every tree tells a story. Our certified team prioritizes safety, precision, and environmental responsibility in every project we undertake. From routine maintenance to emergency services, we deliver excellence with every cut—while always respecting the ecosystem we work in.
              </p>

              {/* Feature Icons */}
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="bg-green-100 p-3 rounded-lg flex-shrink-0">
                    <Shield className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Fully Licensed & Insured</h3>
                    <p className="text-gray-600">Complete protection for your property and peace of mind</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="bg-green-100 p-3 rounded-lg flex-shrink-0">
                    <Leaf className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Certified Arborists</h3>
                    <p className="text-gray-600">Expert tree care from trained and certified professionals</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="bg-green-100 p-3 rounded-lg flex-shrink-0">
                    <Clock className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">24/7 Emergency Service</h3>
                    <p className="text-gray-600">Always available when you need us most</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
